export default {
  zh_cn: "中文",
  en: "English", //英语
  fr: "Français", //法语
  de: "Deutsch", //德语
  ru: "Русский", //俄语
  es: "Español", //西班牙语
  pt: "Português", //葡萄牙语
  jp: "日本語", //日语
  ko: "한국어" //韩语
};
